export default __webpack_public_path__ + "static/media/white-curved.a5b7db66.jpeg";